:host {
  display: block;
}

@media screen and (max-width: 979px) {
  .related-product-dialog {
    padding: 10px 0;
  }
}

@media screen and (min-width: 980px) {
  :host(:not([dir="rtl"])) .related-product-dialog {
    padding: 0 25px 10px 40px;
  }

  :host([dir="rtl"]) .related-product-dialog {
    padding: 0 40px 10px 25px;
  }
}

@media screen and (max-width: 979px) {
  .related-product-dialog__card {
    padding: 20px 25px;
  }
}

@media screen and (min-width: 980px) {
  .related-product-dialog__card {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}

.related-product-dialog__card + .related-product-dialog__card {
  border-top-style: solid;
  border-top-color: #f3f2f2;
}

@media screen and (max-width: 979px) {
  .related-product-dialog__card + .related-product-dialog__card {
    border-top-width: 2px;
  }
}

@media screen and (min-width: 980px) {
  .related-product-dialog__card + .related-product-dialog__card {
    border-top-width: 1px;
  }
}